import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthGuard, I18nModule, provideConfig } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbCustomerIdDropdownModule } from '../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbreturnrequestformComponent } from './kbreturnrequestform/kbreturnrequestform.component';
import { kbRequiredErrorDivModule } from '../kb-Brake-Applications/kbrequiredErrdiv.module';
import { KbReturnRequestForm } from './kb-returnRequest.service';
import { KbReturnRequestFileService } from './kb-returnRequestFile.service';
import { ReturnRequestFileUploadComponent } from './return-request-file-upload/return-request-file-upload.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        PageSlotModule,
        KbMyAccountLeftSideNavModule,
        KbCustomerIdDropdownModule,
        I18nModule,
        MatExpansionModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        BsDatepickerModule,
        kbRequiredErrorDivModule,
        MatDialogModule
    ],
    declarations: [KbreturnrequestformComponent, ReturnRequestFileUploadComponent],
    providers: [
        provideConfig({
            cmsComponents: {
                KbReturnRequestFormFlexComponent: {
                    component: KbreturnrequestformComponent,
                    guards: [AuthGuard, SecureGuard]
                }
            }
        }),
        { provide: KbReturnRequestForm },
        { provide: KbReturnRequestFileService }
    ]
})
export class KbReturnRequestModule { }
